import { render, staticRenderFns } from "./updateNoteModal.vue?vue&type=template&id=313edb9e&scoped=true&"
import script from "./updateNoteModal.vue?vue&type=script&lang=js&"
export * from "./updateNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./updateNoteModal.vue?vue&type=style&index=0&id=313edb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313edb9e",
  null
  
)

export default component.exports